import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FieldLabelToolTip from '../../../../../common/FieldLabelToolTip/fieldLabelToolTip';

import { accordionFieldsMap, getAccordionTitle, getCountryAccordions } from '../../../../ProductRequests/CaptureProductCorporateCard/mappingFile';

import { Translations, createDisplayString, getRandomNumber } from '../../../../../../utils';

import './styles.css';

const CHK_BOX = 'CHECKED';
const UNCHK_BOX = 'UNCHECKED';

class CCAccordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accordionData: this.props.accordionData,
      accordionAemData: this.props.accordionAemData,
      taxonomyData: this.props.taxonomyData !== undefined && this.props.taxonomyData.responseData !== undefined ? this.props.taxonomyData.responseData.classificationNodes : [],
      productReferenceObjects: this.props.productReferenceObjects !== undefined ? this.props.productReferenceObjects : []
    }
  }



  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(this.props.accordionData) !== JSON.stringify(nextProps.accordionData)) {
      this.setState({
        accordionData: nextProps.accordionData,
        accordionAemData: nextProps.accordionAemData,
        taxonomyData: this.props.taxonomyData.responseData.classificationNodes,
        productReferenceObjects: this.props.productReferenceObjects || []
      })
    }
  }

  renderAccordionHeading = (accordionName) => {
    let _accName = getAccordionTitle(accordionName);
    return (
      <div className="gdocs-cc-accordion-heading-main-div">
        {_accName.toUpperCase()}
      </div>
    )
  }

  renderKeyValuePair = (displayKey, displayValue = undefined, subItem = false, checkBoxItem = undefined, tooltip = undefined, displayId = undefined, itemLable = undefined, labelName = undefined, isDisplay= '') => {
    if (displayKey && !displayValue && !subItem && !checkBoxItem) {
      return (
        <dl key={displayKey + getRandomNumber(9999)} className="gdocs-preview-heading-text-main-div">{displayKey}</dl>
      )
    } else if (displayKey && !displayValue && !subItem) {
      return (
        <dl key={displayKey + getRandomNumber(9999)} className="gdocs-preview-heading-text-main-div" style={{ display: 'flex' }}>
          <dt style={{ marginRight: '1rem' }}><i className={`icon ${checkBoxItem === CHK_BOX ? 'icon-ballot-box-with-check' : 'icon-ballot-box'} gdocs-valign-middle hintText-icon`}></i></dt>
          <dd>{displayKey}</dd>
        </dl>
      )
    } else if (!displayKey && !displayValue && !subItem && itemLable && itemLable.currency !== undefined && itemLable.currency.length > 0) {
      return (
        <dl key={displayKey + getRandomNumber(9999)} className="gdocs-preview-heading-text-main-div" style={{ display: 'flex' }}>
            <dt style={{ marginRight: '12rem', fontSize: '.9rem', width: '20rem' }}>{Translations(itemLable.cardName, this.props.lang.currentLang.lang, this.props.lang.translatedData)}</dt>
            {itemLable.currency.map((item) => (
            <dd style={{ marginRight: '.3rem' }}>
              <span style={{ marginRight: '.3rem' }}><i className={`icon ${checkBoxItem === item.CHK_BOX ? 'icon-ballot-box-with-check' : 'icon-ballot-box'} gdocs-valign-middle hintText-icon`}></i></span>
              <span>{item.name}</span>
            </dd>
          ))}
          {itemLable.currencyType !== undefined ? itemLable.currencyType.map((val) => (
            <dd>
              <span><i className={`icon ${checkBoxItem === val.CHK_BOX ? 'icon-ballot-box-with-check' : 'icon-ballot-box'} gdocs-valign-middle hintText-icon`}></i></span>
              <span>{val.name}</span>
            </dd>
          )) : ''}
        </dl>
      )
    } else if (displayKey && !displayValue && subItem) {
      return (
        <dl key={displayId}>
          <span>
            <i className="icon icon-chevron-right-small gdocs-valign-middle gdocs-mleft-5 hintText-icon">
            </i>
          </span>
          {displayKey}
        </dl>
      )
    } else {
      if (!displayKey && displayValue) {
        if (checkBoxItem) {
          return (
            <dl className="dl-horizontal-achCredit" key={displayValue + getRandomNumber(9999)}>
              <dt style={{ width: '100%', display: 'flex' }}>
                <span style={{ marginRight: '1rem' }}><i className={`icon ${checkBoxItem === CHK_BOX ? 'icon-ballot-box-with-check' : 'icon-ballot-box'} gdocs-valign-middle hintText-icon`}></i></span>
                <span>{displayValue}</span>
              </dt>
            </dl>
          )
        } else {
          return (
            <dl className="dl-horizontal-achCredit" key={displayValue + getRandomNumber(9999)}>
              <dt style={{ width: '100%' }}>{displayValue}</dt>
            </dl>
          )
        }

      } else {
        return (
          <dl className="dl-horizontal-achCredit" key={displayKey + getRandomNumber(9999)} style = {{ display: isDisplay }}>
            <dt>{displayKey}</dt>
            <dd>{displayValue}</dd>
          </dl>
        )
      }
    }

  }

  getLabelFromAemData = (fieldName) => {
    if (fieldName.split('-').length > 1) {
      //In case the field is part of aggregate form box components,e.g. 'aggregateFromBoxName-ComponentName'

    } else {
      //When field is a simple field
      //In case the field is a dropdown also return the display key array, e.g. [["accountType.name","account.country.name"],["account.branch"]]
      let labelKey = this.state.accordionAemData[fieldName]['label'] || this.state.accordionAemData[fieldName]['title'] || undefined;
      let dropDownDisplayKey = !fieldName.startsWith('guideradiobutton_') ? (this.state.accordionAemData[fieldName]['options'] || undefined) : undefined;

      let label = labelKey ? Translations(labelKey, this.props.lang.currentLang.lang, this.props.lang.translatedData) : 'Field label not found';
      let displayKey = dropDownDisplayKey ? JSON.parse(Translations(dropDownDisplayKey, this.props.lang.currentLang.lang, this.props.lang.translatedData)) : undefined;

      let fieldLabelObject = {
        label,
        displayKey
      }
      return fieldLabelObject;
    }
  }

  getValueFromAccordionData = (currentValue, _displayKey = undefined) => {
    if ((typeof currentValue === 'string') && (currentValue.startsWith('urn:uuid:'))) {
      //This is an id referring to an object in the productReferenceObjects
      let _objectForCurrentId = this.state.productReferenceObjects.filter(refObject => refObject.id === currentValue);
      if (_objectForCurrentId && _objectForCurrentId.length === 1) {
        return (
          <div dangerouslySetInnerHTML={createDisplayString(_objectForCurrentId[0], _displayKey)} />
        )
      } else {
        //In case duplicate id exists or id is not found in ACH product data, id should be returned for display.
        return currentValue;
      }
    } else if ((typeof currentValue === 'object')) {
      if (currentValue instanceof Array) {
        return currentValue;
      } else {
        return currentValue.name || 'Value NA';
      }
    } else {
      return currentValue;
    }
  }

  getLabelFromTaxonomy = (parentChain, child, taxItem) => {
    let _taxonomyData = this.props.taxonomyData !== undefined && this.props.taxonomyData.responseData !== undefined ? this.props.taxonomyData.responseData.classificationNodes : [];
    let parentChainItems = parentChain.split('-');
    let itemLable = {};
    let { accordionAemData, accordionName, accordionData, addDetails } = this.props;
    let taxanomy = _taxonomyData.find(x => x.id === addDetails.country.value);
    let currencyType = [];
    let cardType = [];
    let res = accordionData.cardAndCurrencies !==undefined ? accordionData.cardAndCurrencies : [];
     if (res !== undefined && res.length > 0) {
       for (let i of res) {
         for (let curr of i.currencyLst) {
           currencyType.push(curr);
         }
       }
       for (let i of res) {
         cardType.push(i.cardType);
       }
     }
    if (parentChain === 'currencyType' && taxanomy !== undefined) {
      for (let item of taxanomy.associations) {
        let currencies = [];
        let checkItem = {};
        let splitItemId = item.id.split(':')
        if (splitItemId[splitItemId.length - 1] === child) {
          itemLable.cardName = accordionAemData[taxItem].title;
          let curr = item.associations;
          curr = curr.map((x, i) =>{
            return{
              id: x.id,
              name: x.name,
              order: i
            }
          })
          let intersection = [];
          let difference = [];
          intersection = curr.filter(o => currencyType.some(({ value }) => o.id === value));
          if (intersection.length !== curr.length || intersection.length === 0) {
            if (intersection.length === 0) {
              difference = curr.filter(o => currencyType.some(({ id }) => o.id !== id));
            } else {
              difference = curr.filter(o => intersection.some(({ id }) => o.id !== id));
            }
          }
          intersection = intersection.map(item => {
            return {
              name: item.name,
              id: item.id,
              CHK_BOX: 'CHECKED',
              order: item.order
            }
          })
          difference = difference.map(item => {
            return {
              name: item.name,
              id: item.id,
              CHK_BOX: 'UNCHECKED',
              order : item.order
            }
          })
          currencies = [...intersection, ...difference]
          console.log('currencies----', currencies);
          let uniqueCurr = [];
          currencies.map(x => uniqueCurr.filter(a => a.id === x.id && a.CHK_BOX !== 'UNCHECKED').length > 0 ? null : uniqueCurr.push(x));
          uniqueCurr.sort((a, b) => a.order - b.order);

          itemLable.currency = uniqueCurr;
        }
      }
    } if (parentChain === 'cardType' && taxanomy !== undefined) {
      let currArr = currencyType;
      let currencyArr = [];
      for (let i = 0; i < currArr.length; i++) {
        let splitItem = currArr[i].value.split(':');
        let str = splitItem.splice(splitItem.length - 2);
        let Id = str.join(':');
        currencyArr.push({ name: currArr[i].name, value: Id })
      }
      for (let item of taxanomy.associations) {
        let splitItemId = item.id.split(':')
        if (splitItemId[splitItemId.length - 1] === child) {
          itemLable.cardName = accordionAemData[taxItem].title;

          let curr = item.associations;
          curr = curr.map((x, i) =>{
            return{
              id: x.id,
              name: x.name,
              order: i
            }
          })
          curr = curr.map(val => {
            return {
              name: val.name,
              CHK_BOX: cardType.find(x => x.value === val.id) ? 'CHECKED' : 'UNCHECKED',
              order : val.order
            }
          });
          itemLable.currency = curr;

          let assoc = item.associations[0];
          assoc = assoc.associations.map(x => {
            return {
              name: x.name,
              CHK_BOX: this.isCurrencyChecked(currencyArr, x.id),
              order : x.order
            }
          });
          assoc.sort((a, b) => a.order - b.order);
          itemLable.currencyType = assoc;
        }
      }
    }
    if (parentChain === 'specificDetailsMandatoryCheck') {
      itemLable.name = Translations(accordionAemData[taxItem].title, this.props.lang.currentLang.lang, this.props.lang.translatedData) //accordionAemData[taxItem].title || undefined;
      itemLable.value = this.props.accordionData.specificDetailsMandatoryCheck || undefined;
    }
    if (parentChain === 'addressAndContactMandatoryCheck') {
      itemLable.name = Translations(accordionAemData[taxItem].title, this.props.lang.currentLang.lang, this.props.lang.translatedData) //accordionAemData[taxItem].title || undefined;
      itemLable.value = this.props.accordionData.addressAndContactMandatoryCheck || undefined;
    }
    if (parentChain === 'b2bSolution') {
      itemLable.name = Translations(accordionAemData[taxItem].title, this.props.lang.currentLang.lang, this.props.lang.translatedData) //accordionAemData[taxItem].title || undefined;
      itemLable.value = this.props.accordionData.b2bSolution || undefined;
    }
    return itemLable;
  }

  isCurrencyChecked = (currency, id) => {
    let splitItem = id.split(':');
    let str = splitItem.splice(splitItem.length - 2);
    let Id = str.join(':');
    let check = currency.find(x => x.value === Id) ? 'CHECKED' : 'UNCHECKED'
    return check;
  }

  getAggregateFormComponentsWithLabel = (aggFormName) => {
    let componentsKey = this.state.accordionAemData[aggFormName]['components'] || undefined;
    let aggregateFormName = this.state.accordionAemData[aggFormName]['name'] ? Translations(this.state.accordionAemData[aggFormName]['name'], this.props.lang.currentLang.lang, this.props.lang.translatedData) : undefined;
    let aggregateFormTitle = this.state.accordionAemData[aggFormName]['title'] && this.state.accordionAemData[aggFormName]['title'].trim() !== '' ? Translations(this.state.accordionAemData[aggFormName]['title'], this.props.lang.currentLang.lang, this.props.lang.translatedData) : undefined;
    let aggFormComponents = [];
    let _formComponents;
    if (componentsKey) {
      _formComponents = JSON.parse(Translations(componentsKey, this.props.lang.currentLang.lang, this.props.lang.translatedData) || JSON.stringify(componentsKey));
    } else {
      _formComponents = [];
    }

    //Get the individual component label and pass it as object in an array to the calling function;
    let _labelKey, label, name, _dropDownDisplayKey, displayKey, fieldType, inputPrefix;
    for (let component of _formComponents) {
      if (component.fieldType === 'aggregateForm') {
        name = component.name;
        fieldType = component.fieldType || undefined;
        _labelKey = component.label || component.title || undefined;
        label = _labelKey ? Translations(_labelKey, this.props.lang.currentLang.lang, this.props.lang.translatedData) : undefined;

        let innerAggFormComp = [];
        let _inner_agg_formComponents = JSON.parse(Translations(component.components, this.props.lang.currentLang.lang, this.props.lang.translatedData));
        for (let inner_component of _inner_agg_formComponents) {
          let name = inner_component.name;
          let fieldType = inner_component.fieldType || undefined;
          let inputPrefix = inner_component.inputPrefix || undefined;

          let _inner_labelKey = inner_component.label || inner_component.title || undefined;
          let label = _inner_labelKey ? Translations(_inner_labelKey, this.props.lang.currentLang.lang, this.props.lang.translatedData) : 'Field label not found';

          let _inner_dropDownDisplayKey = inner_component.options || undefined;
          let displayKey = _inner_dropDownDisplayKey ? JSON.parse(Translations(_inner_dropDownDisplayKey, this.props.lang.currentLang.lang, this.props.lang.translatedData)) : undefined;

          let inner_prepareLabelObject = {
            name,
            label,
            displayKey,
            fieldType,
            inputPrefix
          };

          innerAggFormComp.push(inner_prepareLabelObject)

        }
        let finalAggBoxObj = {
          name,
          fieldType,
          label,
          ['components']: [...innerAggFormComp]
        }
        aggFormComponents.push(finalAggBoxObj);
      } else {
        name = component.name;
        fieldType = component.fieldType || undefined;
        inputPrefix = component.inputPrefix || undefined;
        if (component.fieldType === 'groupCheckBox') {
          _labelKey = this.getLabelFromTaxonomy(component.name, component.name, '');
          label = _labelKey.name;
        } else {
          _labelKey = component.label || component.title || undefined;
          label = _labelKey ? Translations(_labelKey, this.props.lang.currentLang.lang, this.props.lang.translatedData) : 'Field label not found';
        }

        _dropDownDisplayKey = component.options || undefined;

        displayKey = _dropDownDisplayKey ? JSON.parse(Translations(_dropDownDisplayKey, this.props.lang.currentLang.lang, this.props.lang.translatedData)) : undefined;

        let prepareLabelObject = {
          name,
          label,
          displayKey,
          fieldType,
          inputPrefix
        };
        aggFormComponents.push(prepareLabelObject);
      }
    }

    let prepareAggregateBoxObject = {
      aggregateFormName,
      aggregateFormTitle,
      aggFormComponents
    }
    return prepareAggregateBoxObject;
  }

  renderAggregateFormComponent = (aggBoxTitle = '', aggBoxComponents, aggBoxData = [], aggBoxName) => {
    let _partialAggBoxJsx = [];
    let _aggBoxEnclosingDiv;
    if (aggBoxTitle && aggBoxTitle.trim !== "") {
      _partialAggBoxJsx.push(this.renderKeyValuePair(aggBoxTitle));
    }

    let _aggBoxFieldsJsx = [];
    if (aggBoxData.length > 0) {
      for (let i = 0; i < aggBoxData.length; i++) {
        //If the typeof aggregate box data is a string it is guranteed that the aggregate box has only one component
        if (typeof aggBoxData[i] === 'string') {
          for (let comp of aggBoxComponents) {
            if (aggBoxData[i]) {
              let _displayKey = comp.displayKey || undefined;
              let componentValue = this.getValueFromAccordionData(aggBoxData[i], _displayKey) || ' ';
              _aggBoxFieldsJsx.push(this.renderKeyValuePair(`${comp.label}${(i >= 0) ? ` ${i + 1}` : ''}`, componentValue));
            }
          }
          if (i < aggBoxData.length && i !== aggBoxData.length - 1) {
            _aggBoxFieldsJsx.push(<hr key={`separatorKey${i}-${getRandomNumber(9999)}`} className="gdocs-preview-aggregate-single-component-separator" />);
          }
        } else {
          //If aggregate box data type is object
          let compIdx = 0;
          for (let comp of aggBoxComponents) {
            if (aggBoxData[i][comp.name]) {
              let _displayKey = comp.displayKey || undefined;
              let componentValue = this.getValueFromAccordionData(aggBoxData[i][comp.name], _displayKey);
              if (comp.fieldType === 'aggregateForm') {
                _aggBoxFieldsJsx.push(...this.renderAggregateFormComponent(comp.label, comp.components, aggBoxData[i][comp.name], comp.name))
              } else {
                if (comp.fieldType === 'groupCheckBox' && ((componentValue instanceof Array && componentValue.length > 0) || !componentValue)) {
                  if (!componentValue) {
                    componentValue = [];
                  }
                  _aggBoxFieldsJsx.push(this.renderGroupCheckBoxes(comp, componentValue));
                } else {
                  if (!componentValue) {
                    componentValue = ' ';
                  }
                  _aggBoxFieldsJsx.push(this.renderKeyValuePair(`${comp.label}${(i >= 0) && (comp.mandatory || compIdx == 0) ? ` ${i + 1}` : ''}`, componentValue));
                }
              }
              compIdx++;
            }
          }
          if (i < aggBoxData.length && i !== aggBoxData.length - 1) {
            _aggBoxFieldsJsx.push(<hr key={'aggregate-box-separator-' + i + '-' + getRandomNumber(9999)} className="gdocs-preview-aggregate-multi-component-separator" />);
          }
        }
      }
      _aggBoxEnclosingDiv = (
        <div className="aggregate-box-enclosing-main-div" key={'aggregate-form-box-' + `${aggBoxName}-` + getRandomNumber(9999)}>
          {_aggBoxFieldsJsx}
        </div>
      );
      _partialAggBoxJsx.push(_aggBoxEnclosingDiv)
    } else if (typeof aggBoxData === 'object' && !(aggBoxData instanceof Array)) {
      //This case is applicable to firstparty and secondParty narrative in non-UK payment types and reversalAccount of HK
      let ctr = 0;
      if (Object.keys(aggBoxData).length > 0) {
        for (let comp of aggBoxComponents) {
          if (aggBoxData[comp.name]) {
            let _displayKey = comp.displayKey || undefined;
            let displayLabel = comp.label;
            if (aggBoxName === 'firstParty' || aggBoxName === 'secondParty') {
              displayLabel = ' ';
              if (ctr === 0) {
                displayLabel = comp.label || 'Field Label Loading'
              }
            }
            let componentValue = this.getValueFromAccordionData(aggBoxData[comp.name], _displayKey);
            if (comp.fieldType === 'groupCheckBox' && componentValue instanceof Array && componentValue.length > 0) {
              _aggBoxFieldsJsx.push(this.renderGroupCheckBoxes(comp, componentValue));
            } else {
              let _displayVal;
              if (comp.inputPrefix) {
                _displayVal = `(${comp.inputPrefix}) ${componentValue}`;
              } else {
                _displayVal = componentValue;
              }
              _aggBoxFieldsJsx.push(this.renderKeyValuePair(displayLabel, _displayVal));
            }
            ctr++;
          }
        }
      }
      _aggBoxEnclosingDiv = (
        <div key={'aggregate-form-box-' + `${aggBoxName}-` + getRandomNumber(9999)}>
          {_aggBoxFieldsJsx}
        </div>
      );
      _partialAggBoxJsx.push(_aggBoxEnclosingDiv)
    }

    return _partialAggBoxJsx;
  }

  renderAccordionFields = (accordionFields, formData = this.props.accordionData) => {
    let _accordionFieldsJsx = [];
    let isB2B = false;
    for (let item of accordionFields) {
      switch (typeof item) {
        case 'object': {
          if (item instanceof Array) {
            _accordionFieldsJsx.push(...this.renderAccordionFields(item, formData));
          } else {
            for (let [itemKey, itemValue] of item.entries()) {
              if (itemKey.startsWith('static_text')) {
                _accordionFieldsJsx.push(this.renderKeyValuePair(itemValue.split('$')[0]));
              } else {
                _accordionFieldsJsx.push(...this.renderAccordionFields([itemKey, ...itemValue], formData));
              }
            }
          }
          break;
        }
        case 'string': {
          let splitItem = item.split(':');
          if (splitItem.length > 1) {
            let splitForChild = splitItem[1].split('_');
            let _initTaxonomyData = this.state.taxonomyData;
            let itemLable = this.getLabelFromTaxonomy(splitItem[0], splitForChild[1], splitItem[1]);

            if (splitForChild[0].startsWith('guidecheckbox')) {
              let accordionFieldValue;
              accordionFieldValue = formData[splitItem[0]] || undefined;
              let b2bSol = splitItem[0];
              if (b2bSol === 'b2bSolution') {
                let curr = formData['currencyType'];
                if (curr !== undefined && curr.length > 0) {
                  for (let i = 0; i < curr.length; i++) {
                    let fields = curr[i].value.split(':');
                    if (fields.length > 0) {
                      if (fields[fields.length - 2] === 'CCIndividualPay' || fields[fields.length - 2] === 'CCCentralPay') {
                        isB2B = true;
                      }
                    }

                  }
                }
              }
              if (accordionFieldValue) {
                if (typeof accordionFieldValue === 'object' && accordionFieldValue instanceof Array) {
                  let dataIdx;
                  accordionFieldValue = accordionFieldValue.filter((checkBoxItem, idx) => {
                    let splitCheckBox;
                    if (splitItem[0] === 'currencyType') {
                      dataIdx = idx;
                      return checkBoxItem;
                    } if (splitItem[0] === 'cardType') {
                      dataIdx = idx;
                      return checkBoxItem;
                    }
                    if (splitCheckBox[splitCheckBox.length - 2] === splitForChild[1]) {
                      dataIdx = idx;
                      return checkBoxItem;
                    }
                  });

                  if (accordionFieldValue && accordionFieldValue.length === 1) {
                    if (splitItem[0] === 'currencyType') {
                      _accordionFieldsJsx.push(this.renderKeyValuePair(undefined, undefined, undefined, CHK_BOX, undefined, undefined, itemLable));
                    } if (splitItem[0] === 'specificDetailsMandatoryCheck' || splitItem[0] === 'addressAndContactMandatoryCheck' || (splitItem[0] === 'b2bSolution' && isB2B === true)) {
                      _accordionFieldsJsx.push(this.renderKeyValuePair(itemLable.name.toUpperCase(), undefined, undefined, CHK_BOX, itemLable.tooltip, itemLable.value, itemLable));
                    } if (splitItem[0] === 'cardType') {
                      _accordionFieldsJsx.push(this.renderKeyValuePair(undefined, undefined, undefined, CHK_BOX, undefined, undefined, itemLable));
                    }
                  } else {
                    if (splitItem[0] === 'currencyType') {
                      _accordionFieldsJsx.push(this.renderKeyValuePair(undefined, undefined, undefined, CHK_BOX, undefined, undefined, itemLable));
                    } if (splitItem[0] === 'specificDetailsMandatoryCheck' || splitItem[0] === 'addressAndContactMandatoryCheck' || (splitItem[0] === 'b2bSolution' && isB2B === true)) {
                      _accordionFieldsJsx.push(this.renderKeyValuePair(itemLable.name.toUpperCase(), undefined, undefined, CHK_BOX, itemLable.tooltip, itemLable.value, itemLable));
                    } if (splitItem[0] === 'cardType') {
                      _accordionFieldsJsx.push(this.renderKeyValuePair(undefined, undefined, undefined, CHK_BOX, undefined, undefined, itemLable));
                    }
                  }
                } else if (typeof accordionFieldValue === 'object' && !(accordionFieldValue instanceof Array)) {
                  accordionFieldValue = accordionFieldValue.name || ' ';
                  _accordionFieldsJsx.push(this.renderKeyValuePair(undefined, itemLable.name, undefined, CHK_BOX, itemLable.tooltip, itemLable.value, itemLable));
                } else {
                  if (!accordionFieldValue) {
                    _accordionFieldsJsx.push(this.renderKeyValuePair(undefined, itemLable.name, undefined, UNCHK_BOX, itemLable.tooltip, itemLable.value, itemLable));
                  }
                  if (splitItem[0] === 'specificDetailsMandatoryCheck' || splitItem[0] === 'addressAndContactMandatoryCheck' || (splitItem[0] === 'b2bSolution' && isB2B === true)) {
                    _accordionFieldsJsx.push(this.renderKeyValuePair(itemLable.name, undefined, undefined, CHK_BOX, itemLable.tooltip, itemLable.value, itemLable));
                  }
                }
              } else {
                //Display checkbox labels with unchecked box in case corresponding value is not present.
                if (!accordionFieldValue) {
                  if (splitItem[0] === 'currencyType') {
                    _accordionFieldsJsx.push(this.renderKeyValuePair(itemLable.name.toUpperCase(), undefined, undefined, UNCHK_BOX, itemLable.tooltip, itemLable.value, itemLable));
                  } if (splitItem[0] === 'specificDetailsMandatoryCheck' || splitItem[0] === 'addressAndContactMandatoryCheck' || (splitItem[0] === 'b2bSolution' && isB2B === true)) {
                    _accordionFieldsJsx.push(this.renderKeyValuePair(itemLable.name, undefined, undefined, UNCHK_BOX, itemLable.tooltip, itemLable.value, itemLable));
                  } if (splitItem[0] === 'cardType') {
                    _accordionFieldsJsx.push(this.renderKeyValuePair(undefined, undefined, undefined, UNCHK_BOX, undefined, undefined, itemLable));
                  }
                }
              }
            }
            else {
              if (splitForChild[0].startsWith('guideradiobutton')) {
                let accordionFieldValue = formData[splitItem[0]] || undefined;
                if (accordionFieldValue && typeof accordionFieldValue === 'object' && Object.keys(accordionFieldValue).length > 1) {
                  // accordionFieldValue = accordionFieldValue.name || 'No Name Found';
                  _accordionFieldsJsx.push(this.renderKeyValuePair(itemLable.name, accordionFieldValue.name || 'No Name Found'));
                  if (splitItem[0] === 'electronicReportFormats') {
                    let splitAccordionFieldValue = accordionFieldValue.value.split(':');
                    let electronicRptFmtValue = splitAccordionFieldValue[splitAccordionFieldValue.length - 2];
                    //For electronic report format radio button the next field is a map in the array having keys-> full,summary
                    if (accordionFields[1].has(`${splitItem[0]}:${electronicRptFmtValue}`)) {
                      let selectedElectronicRptFmt = accordionFields[1].get(`${splitItem[0]}:${electronicRptFmtValue}`);
                      _accordionFieldsJsx.push(...this.renderAccordionFields(selectedElectronicRptFmt));
                    }
                    accordionFields.length = 1;
                  }
                } else {
                  if (!accordionFieldValue) {
                    _accordionFieldsJsx.push(this.renderKeyValuePair(itemLable.name, ' '));
                  } else {
                    _accordionFieldsJsx.push(this.renderKeyValuePair(itemLable.name, itemLable.value));
                  }

                }
              } else {
                _accordionFieldsJsx.push(this.renderKeyValuePair(itemLable.name, item.toUpperCase()));
              }

            }


          } else {
            //for aggregateFormBox, drop down, text box
            //access state accordion data -> this.state.accordionData
            if (!item.startsWith('guidebutton_')) {
              if (item.startsWith('guideaggregateformbox_')) {
                let aggregateFromDetails = this.getAggregateFormComponentsWithLabel(item);
                let componentsArray = aggregateFromDetails.aggFormComponents;
                let aggFromTitle = aggregateFromDetails.aggregateFormTitle;
                let aggFromName = aggregateFromDetails.aggregateFormName;
                let currentAggregateBoxData = formData[item.split('_')[1]] || undefined;
                // if(currentAggregateBoxData && (currentAggregateBoxData.length>0 || Object.keys(currentAggregateBoxData).length>0)){
                _accordionFieldsJsx.push(...this.renderAggregateFormComponent(aggFromTitle, componentsArray, currentAggregateBoxData, aggFromName));
                // }

              } else {
                let key;
                if(item.startsWith('static_text')){
                  key =item.split('_')[2];
                }
                else{
                  key =item.split('_')[1];
                }
                let _currentDataKey = formData[key];
                let accordionFieldLabel = this.getLabelFromAemData(item);
                if (_currentDataKey && (typeof _currentDataKey !== 'boolean')) {
                  switch (typeof _currentDataKey) {
                    case 'string': {
                      let name = this.showHideFields(key);
                      let accordionFieldValue = this.getValueFromAccordionData(_currentDataKey, accordionFieldLabel.displayKey);
                      _accordionFieldsJsx.push(this.renderKeyValuePair(accordionFieldLabel.label, accordionFieldValue, undefined, undefined, undefined, undefined, undefined, key, name));
                      break;
                    }
                    case 'object': {
                      if (_currentDataKey instanceof Array) {
                        let accordionFieldValue = _currentDataKey[0].name || undefined;
                        if (accordionFieldValue) {
                          _accordionFieldsJsx.push(this.renderKeyValuePair(accordionFieldLabel.label, accordionFieldValue));
                        }
                      } else {
                        let accordionFieldValue = _currentDataKey.name || 'Value Not Found';
                        _accordionFieldsJsx.push(this.renderKeyValuePair(accordionFieldLabel.label, accordionFieldValue));
                      }
                      break;
                    }
                    default: {
                      break;
                    }
                  }
                } else {
                  if (typeof formData[item.split('_')[1]] === 'boolean') {
                    let accordionFieldLabel = this.getLabelFromAemData(item);
                    if (formData[item.split('_')[1]]) {
                      let accordionFieldValue = "Yes";
                      _accordionFieldsJsx.push(this.renderKeyValuePair(accordionFieldLabel.label, accordionFieldValue));
                    } else if (formData[item.split('_')[1]] === false) {
                      let accordionFieldValue = "No";
                      _accordionFieldsJsx.push(this.renderKeyValuePair(accordionFieldLabel.label, accordionFieldValue));
                      //Resetting the length of accordionFields to 1 so as to prevent subsequent children from rendering
                      accordionFields.length = 1;
                    }
                  } else {
                    //Show labels for fields even when there is no corresponding value present for that label
                    let name = this.showHideFields(key);
                    let accordionFieldLabel = this.getLabelFromAemData(item);
                    _accordionFieldsJsx.push(this.renderKeyValuePair(accordionFieldLabel.label, ' ', undefined, undefined, undefined, undefined, undefined, key, name));
                    if (item.split('_')[1] === 'eChannelType' || item.split('_')[1] === 'frequencyOfSubmission') {
                      //Resetting the length of accordionFields to 1 so as to prevent subsequent children from rendering
                      accordionFields.length = 1;
                    }
                  }
                }
              }
            }

          }
          break;
        }
        default: {
          console.log('Unidentified item for CCAccordion preview: ', item);
        }
      }
    }
    return _accordionFieldsJsx;
  }

  renderAccordionContent = (accordionName, addDetails) => {
    let _countryName = (addDetails.country.value.split(':')[addDetails.country.value.split(':').length - 2].split('-').join('').toLowerCase());
    //Special handling for UK HSBC Bank Plc as the mapping is same for both UK HSBC and UK HSBC Bank Plc.
    if (_countryName === 'unitedkingdomhsbcbankplc') {
      _countryName = 'unitedkingdomhsbcuk';
    }
    let _accordionFieldsKey = _countryName + '_' + accordionName;
    let _accordionFields = accordionFieldsMap.get(_accordionFieldsKey);
    let _accordionJsx = _accordionFields && _accordionFields.length > 0 ? this.renderAccordionFields(_accordionFields) : [];
    return (
      <div className="gdocs-cc-accordion-content-main-div" key={accordionName + getRandomNumber(9999)}>
        {_accordionJsx.length > 0 ? _accordionJsx : ''}
      </div>
    );
  }

  showHideFields = (fieldName) => {
    let formData = this.props.accordionData;
    if (fieldName === 'B2BTextField' || fieldName === 'paymentFacilitatorName' || fieldName === 'merchantIdentificationNumber' || fieldName === 'purposeOfCardPayment' || fieldName === 'supplierNameLst1' ||
      fieldName === 'supplierNameLst2' || fieldName === 'supplierNameLst3' || fieldName === 'supplierNameLst4' || fieldName === 'supplierNameLst5') {
      if (formData.b2bSolution === true) {
        if (fieldName === 'supplierNameLst2' && formData.supplierNameLst2 === undefined) {
          return 'none'
        } if (fieldName === 'supplierNameLst3' && formData.supplierNameLst3 === undefined) {
          return 'none'
        } if (fieldName === 'supplierNameLst4' && formData.supplierNameLst4 === undefined) {
          return 'none'
        } if (fieldName === 'supplierNameLst5' && formData.supplierNameLst5 === undefined) {
          return 'none'
        }
      } else if(formData.b2bSolution === false){
        return 'none'
      }
    }

  }

  render() {
    let { accordionName, addDetails, accordionHeading } = this.props;
    return (
      <div className="gdocs-cc-accordion-main-div">
        {Translations(accordionHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData).toUpperCase()}
        {this.state.accordionAemData ? this.renderAccordionContent(accordionName, addDetails) : ''}
      </div>
    )
  }
}

CCAccordion.propTypes = {
  accordionName: PropTypes.string.isRequired,
  accordionData: PropTypes.object.isRequired,
  addDetails: PropTypes.object.isRequired,
  accordionAemData: PropTypes.object.isRequired,
  newAccounts: PropTypes.array,
  echannels: PropTypes.array,
  aemStaticData: PropTypes.object,
  taxonomyData: PropTypes.object
}

export default CCAccordion;



// WEBPACK FOOTER //
// ./src/components/CaseBody/PreviewRequest/Child/CorporateCard/CCAccordion/CCAccordion.js